import { createSlice } from '@reduxjs/toolkit';

const ACTIVE_DRAFT_ORDER_ID_KEY = 'activeDraftOrderId';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    token: localStorage.getItem('token') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    currentRole: null,
    store: JSON.parse(localStorage.getItem('store')) || null,
    organization: JSON.parse(localStorage.getItem('organization')) || null,
    terminal: JSON.parse(localStorage.getItem('terminal')) || null,
    isInitialized: false,
    sessionExpired: false,
    organizationSuspended: false,
    storeInactive: false,
  },
  reducers: {
    setCredentials: (state, { payload }) => {
      const { user, access_token, refresh_token, store, organization, terminal } = payload || {};

      if (access_token) {
        state.token = access_token;
        localStorage.setItem('token', access_token);
      }

      if (refresh_token) {
        state.refreshToken = refresh_token;
        localStorage.setItem('refreshToken', refresh_token);
      }

      if (user) {
        state.user = user;
        state.currentRole = user.roles && user.roles.length > 0 ? user.roles[0] : null;
      }

      if (store) {
        state.store = store;
        localStorage.setItem('store', JSON.stringify(store));
      }

      if (organization) {
        state.organization = organization;
        localStorage.setItem('organization', JSON.stringify(organization));
      }

      if (terminal) {
        state.terminal = terminal;
        localStorage.setItem('terminal', JSON.stringify(terminal));
      }

      if (state.token && state.user) {
        state.isInitialized = true;
      }
    },

    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.currentRole = null;
      state.store = null;
      state.organization = null;
      state.terminal = null;
      state.isInitialized = false;
      state.sessionExpired = false;
      state.organizationSuspended = false;
      state.storeInactive = false;

      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('store');
      localStorage.removeItem('organization');
      localStorage.removeItem('terminal');
      localStorage.removeItem('cashSession');
      sessionStorage.removeItem(ACTIVE_DRAFT_ORDER_ID_KEY);
    },

    setSessionExpired: (state) => {
      state.sessionExpired = true;
    },

    // The org was suspended (non-payment). A distinct 403 `organization_suspended`
    // key — surfaced on any request, login, or refresh — routes to a dedicated
    // "account suspended" screen rather than a generic auth error.
    setOrganizationSuspended: (state) => {
      state.organizationSuspended = true;
    },

    // The cashier's store was deactivated (taken offline). A 403 "This store is
    // inactive" — on POS login, terminal select, and every request — blocks POS
    // entry for that store rather than surfacing a generic auth error.
    setStoreInactive: (state) => {
      state.storeInactive = true;
    },
  },
});

export const { setCredentials, logout, setSessionExpired, setOrganizationSuspended, setStoreInactive } = authSlice.actions;
export default authSlice.reducer;
